<template>
<div>
    <base-header v-once  :pageName="`${custNm} 상담 리포트 미리보기`" :popup="true"></base-header>

        <section id="wrap" class="consult-log-preview">
            <dt>
                안녕하세요. <span class="bold">{{ custNm }}</span> 고객님<br>
                빨간펜 <span>{{userName}}</span> {{ `${orgnzPstnNm}` }} 입니다.<br>
                오늘 상담 서비스 받으신 내용은
            </dt>
            <dd>
                <span v-for="(item, index) in anpCodes" :key="index">{{item.cdNm}}</span>
            </dd>
        </section>
    <div class="btnWrap">
        <button type="button" @click="closePopup" class="white">수정하기</button>
        <button type="button" @click="counselSend" class="red">전송하기</button>
    </div>
</div>
</template>

<script>
export default {
  data() {
      return{
          kwkkey: "",
          custDiv: "",
          custNm: "",
          anpCodes: [],    // 💡anpList 에 선택된 체크박스 값(cd)이 담길 배열
          ansCode: '',   // 선택된 서비스 코드 (단일)
          userName: this.$utils.ui.getUserName(), // 이름
          orgnzPstnNm: this.$utils.ui.getOrgnzPstnNm(), // 직급
          isSending: false // 전송상태
      };
  },
  methods: {
    closePopup: function() {
        this.$router.go(-1);
    },counselSend: function (){ 
        if (this.isSending) {
        return;
        }

        if (!confirm("전송하시겠습니까?")) {
            return;
        }
        // 전송 상태를 true로 변경하여 락(Lock)
        this.isSending = true;

        var params = {
            custSrno : this.kwkkey, 
            custDiv : this.custDiv,
            actCd : this.ansCode,
            orgnzPstnNm : this.orgnzPstnNm,
            prdtCd1: this.anpCodes.length > 0 ? this.anpCodes[0].cdVl3 : '',
            prdtCd2: this.anpCodes.length > 1 ? this.anpCodes[1].cdVl3 : ''
        };

        this.$api.counsel.counselSend(params)
            .then(function() {
                alert("전송 완료되었습니다.");
                window.close();
            })
            .catch(function(error) {
                alert(error.rtMsg);
            })
            .finally(() => {
            // 3. 성공이든 에러든 통신이 완전히 끝나면 다시 상태를 false로 풀어줍니다.
            // (window.close()가 있어서 창이 닫히면 큰 의미는 없지만, 에러가 났을 때 다시 시도할 수 있게 해줍니다.)
            this.isSending = false;
            });
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'counselView-pop-param'){  // 부모창에서 받은 정보.
            console.log("FamilyInfo.vue mounted this.$store.getters.parent.data", parent.data);
            this.kwkkey = parent.data.kwkkey;
            this.custDiv = parent.data.custDiv;
            this.custNm = parent.data.custNm;
            this.anpCodes = parent.data.anpCodes;
            this.ansCode= parent.data.ansCode;


        }
  }
};
</script>
